import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import About from "./pages/About";
import StudentVisa from "./pages/studentvisa";
import TouristVisa from "./pages/touristvisa";
import USA from "./pages/Usa";
import UK from "./pages/UK";
import Canada from "./pages/Canada";
import AUS from "./pages/AUS";
import Europe from "./pages/Europe";
import IELTS from "./pages/IELTS";
import Doulingo from "./pages/Doulingo";
import Contact from "./pages/Contact";
import TermsAndConditions from "./pages/T&C";
import Blog from "./pages/blog";

import Header from "./components/Header";
import Footer from "./components/Footer";
function App() {
  return (
    <div className="App">
     
      <Router>
       
        <Header />
        <Routes>
         
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/studentvisa" element={<StudentVisa />} />
          <Route path="/touristvisa" element={<TouristVisa />} />
          <Route path="/usaVisa" element={<USA />} />
          <Route path="/ukVisa" element={<UK />} />
          <Route path="/canadaVisa" element={<Canada />} />
          <Route path="/ausVisa" element={<AUS />} />
          <Route path="/europeVisa" element={<Europe />} />
          <Route path="/ielts" element={<IELTS />} />
          <Route path="/doulingo" element={<Doulingo />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/blog" element={<Blog />} />
          {/* Add more routes here as needed */}
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}
export default App;
